import React from 'react';
import { Select, Input, Menu, Icon, Button } from 'antd';


class SourceOfFundsSelector extends React.Component {
    state = {
        selectedKey: this.props.value,
        otherValue: this.props.otherValue
    }
    constructor (props) {
        super(props);
        let selectedKey = this.props.value;

        this.state = {
            selectedKey: selectedKey,
            selectedValue: this.props.value
        }
    }

    componentDidMount() {
        let selectedKeyVal = this.findSelectedKey(this.props.value);
        this.state = {
            selectedKey: selectedKeyVal,
            selectedValue: this.props.value
        }
    }

    findSelectedKey = (value) => {
        if (!value || this.props.sourceOfFunds.length == 0) {
            return null;
        }
        for (let i = 0; i < this.props.sourceOfFunds.length; i++) {
            if (this.props.sourceOfFunds[i].code === value) {
                return this.props.sourceOfFunds[i].code;
            }
        }
        return "OTHERS";
    }

    findByKey = (key) => {
        for (let i = 0; i < this.props.sourceOfFunds.length; i++) {
            if (this.props.sourceOfFunds[i].code === key) {
                return this.props.sourceOfFunds[i];
            }
        }
        return null;
    }

    onOtherValueChanged = (event) => {
        let selectedValueExt = event.target.value;
        this.setState({
            selectedValueExt: selectedValueExt
        }, function() {
            this.props.onChange(this.state.selectedValue,selectedValueExt);
        })
    }

    onSelectValueChanged = (newValue) => {
        if(newValue === "OTHERS"){
            this.setState({
                selectedKey: "OTHERS",
                selectedValue: newValue
            }, function () {
                this.fireChanged();
            })
        } else {
            this.setState({
                selectedKey: newValue,
                selectedValue: this.findByKey(newValue).value,
                selectedValueExt: ''
            }, function () {
                this.fireChanged();
            })
        }
    }

    fireChanged = () => {
        this.props.onChange(this.state.selectedKey, this.state.selectedValueExt);
    }

    render() {
        const sourceOfFunds = this.props.sourceOfFunds;
        const otherValue = this.props.otherValue;
        return (
            <div>
                <Select
                    style={{ width: '100%' }}
                    placeholder={this.props.placeholder}
                    optionFilterProp="children"
                    onChange={this.onSelectValueChanged}
                    value={this.props.value}
                    defaultValue={null}
                    size={this.props.size}
                 >
                    {sourceOfFunds.map((sourceOfFunds, idx) => {
                        return <Select.Option value={sourceOfFunds.code} key={sourceOfFunds.code}>{sourceOfFunds.value}</Select.Option>
                    })}
                </Select>
                {(this.state.selectedKey === "OTHERS" || otherValue) &&
                    <Input onChange={this.onOtherValueChanged} defaultValue={this.props.otherValue}  placeholder={"Please input remarks"} ></Input>
                }
            </div>
        )
    }

}

export default SourceOfFundsSelector;
